var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-card-plans"},[_c('a',{staticClass:"content-card-plans-link",on:{"click":function($event){return _vm.routerPage(_vm.target)}}},[_c('div',{staticClass:"content-card-plans--text"},[_c('h3',[_vm._v(_vm._s(_vm.target.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }